import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const AddUnit = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    // Validate required fields
    UnitInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);
        const payload = {
          unit: formData.name,
          unit_desc: formData.description,
          status: formData.status === true ? 1 : 0,
        };

        const response = await axiosInstance.post("/unit/create", payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          await Swal.fire({
            title: "Success",
            text: "Unit code added successfully.",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          navigate("/admin/manage-logistic/unit");
        }
      } catch (error) {
        console.error("Error adding unit:", error);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while processing your request.";
        await Swal.fire({
          title: "Something went wrong",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate("/admin/manage-logistic/unit");
  };

  const UnitInputs = [
    {
      name: "name",
      label: "Name",
      placeholder: "Enter Unit Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.unitName({ required: true }),
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Unit Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.description({ required: true }),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Unit</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the Unit Details
              </span>
              <DynamicForm
                formConfig={UnitInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(UnitInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  UnitInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddUnit;
